export default "__VITE_ASSET__O4DUA1xx__"